import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const API_BASE = `${environment.apiUrl}/v1`;

export interface Ayuda {
    id: string;
    titulo: string;
    tipo: 'documento' | 'video';
    urlOrPath: string;
    tipoDocumento?: string | null;
    descripcion?: string | null;
    activo: boolean;
    orden: number;
    createdAt: string;
    updatedAt?: string;
}

export interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    timestamp: string;
}

@Injectable({
    providedIn: 'root',
})
export class AyudasService {
    private apiUrl = `${API_BASE}/ayudas`;

    constructor(private http: HttpClient) {}

    private getAuthHeaders(): HttpHeaders {
        const token = localStorage.getItem('access_token');
        return new HttpHeaders({
            Authorization: `Bearer ${token}`,
        });
    }

    getList(): Observable<ApiResponse<Ayuda[]>> {
        return this.http.get<ApiResponse<Ayuda[]>>(this.apiUrl, {
            headers: this.getAuthHeaders(),
        });
    }

    getById(id: string): Observable<ApiResponse<Ayuda>> {
        return this.http.get<ApiResponse<Ayuda>>(`${this.apiUrl}/${id}`, {
            headers: this.getAuthHeaders(),
        });
    }

    create(formData: FormData): Observable<ApiResponse<Ayuda>> {
        return this.http.post<ApiResponse<Ayuda>>(this.apiUrl, formData, {
            headers: this.getAuthHeaders().delete('Content-Type'),
        });
    }

    update(id: string, formData: FormData): Observable<ApiResponse<Ayuda>> {
        return this.http.put<ApiResponse<Ayuda>>(`${this.apiUrl}/${id}`, formData, {
            headers: this.getAuthHeaders().delete('Content-Type'),
        });
    }

    delete(id: string): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`, {
            headers: this.getAuthHeaders(),
        });
    }

    /**
     * Descarga el archivo de una ayuda tipo documento.
     * Retorna el blob para que el componente dispare la descarga con el nombre correcto.
     */
    downloadFile(id: string): Observable<Blob> {
        return this.http.get(`${this.apiUrl}/${id}/download`, {
            headers: this.getAuthHeaders(),
            responseType: 'blob',
        });
    }
}
